// extracted by mini-css-extract-plugin
module.exports = {"suggest":"_6c97079b1b--suggest--Lkaqh","suggest-item":"_6c97079b1b--suggest-item--BczC7","suggest-error":"_6c97079b1b--suggest-error--RHh0N"};